import React, {Component} from 'react'
import Scheduler, {SchedulerData, ViewTypes, DATE_FORMAT} from 'react-big-scheduler'
import withDragDropContext from './withDnDContext'
import 'react-big-scheduler/lib/css/style.css'
import moment from 'moment';
import 'moment/locale/fr';

moment.locale('fr');

let resources = [
    {
        id: 'r1',
        name: 'Audits'
    },
   {
        id: 'r2',
        name: 'Trajets'
    },
    {
        id: 'r3',
        name: 'Pauses'
    },
    /*{
        id: 'r4',
        name: 'Pauses'
    }*/
];

let default_schedulerData = new SchedulerData(moment().format(DATE_FORMAT), ViewTypes.Week, false, false, {
    startResizable: false,
    endResizable: false,
    movable: false,
    creatable: false,
    nonAgendaDayCellHeaderFormat: 'HH:mm',
    nonAgendaOtherCellHeaderFormat: 'ddd|D/M',
    minuteStep: 15,
});
default_schedulerData.setLocaleMoment(moment);
default_schedulerData.setResources(resources);

class Readonly extends Component{
    constructor(props){
        super(props);

        this.state = {
            audit_duration: 1,
            ready: false,
            viewModel: default_schedulerData
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.audits && nextProps.audits.length > 0){
            if(!this.state.ready)
                default_schedulerData.setDate(moment(nextProps.audits[0].date).format(DATE_FORMAT))
            default_schedulerData.setEvents(this.formatAudits(nextProps.audits, nextProps.directions));
            default_schedulerData.setResources(resources);
            this.setState({
                viewModel: default_schedulerData,
                ready: true,
            });
        }
    }

    render(){
        const {viewModel} = this.state;
        return (
            <div>
                <div>
                    <Scheduler schedulerData={viewModel}
                               prevClick={this.prevClick}
                               nextClick={this.nextClick}
                               onSelectDate={this.onSelectDate}
                               onViewChange={this.onViewChange}
                               eventItemClick={this.eventClicked}
                    />
                </div>
            </div>
        )
    }

    formatAudits(audits, directions){

        var legs = null;
        if(directions){
            legs = directions.routes[0].legs;
        }

        var data = audits.map((audit, index)=>{
            return {
                id: "audit_"+audit.id,
                start: moment(audit.date).format("YYYY-MM-DD HH:mm:ss"),
                end: moment(audit.date).add(this.state.audit_duration, 'hours').format("YYYY-MM-DD HH:mm:ss"),
                resourceId: 'r1',
                title: audit.company.name,
                bgColor: '#5398f7',
            };
        })

        //Audits optimisé
        var optimized = this.props.optimized_waypoint_order;
        if(optimized && optimized.length > 0) {
            for (var h = 0; h < optimized.length; h++) {
                var index = optimized[h]
                data.push({
                    id: "audit_" + audits[index].id,
                    start: moment(audits[h].date).format("YYYY-MM-DD HH:mm:ss"),
                    end: moment(audits[h].date).add(this.state.audit_duration, 'hours').format("YYYY-MM-DD HH:mm:ss"),
                    resourceId: 'r3',
                    title: h+ " " + audits[index].reference,
                    bgColor: '#64d6f7',
                })
            }
        }

        //Trajets
        if(legs){
            for (var i = 0; i < audits.length; i++){
                var date_start = moment(audits[i].date);
                var date_start_end = moment(audits[i].date);

                if(i > 0) {
                    var start = moment(audits[i - 1].date).add(this.state.audit_duration, "hours");
                    var end = moment(audits[i].date).subtract(5, "minutes").subtract(Math.round(legs[i].duration.value), 'seconds');
                    var ms = end.diff(start);
                    var d = moment.duration(ms);
                    data.push({
                        id: "waiting_" + audits[i].id,
                        start: moment(audits[i - 1].date).add(this.state.audit_duration, "hours").format("YYYY-MM-DD HH:mm:ss"),
                        end: moment(audits[i].date).subtract(5, "minutes").subtract(Math.round(legs[i].duration.value), 'seconds').format("YYYY-MM-DD HH:mm:ss"),
                        resourceId: 'r2',
                        title: "Attente de " + (d.days() > 0 ? (d.days() + " jours et ") : "") + d.hours() + 'h ' + d.minutes(),
                        bgColor: '#f7c96d',
                    });
                }

                data.push({
                    id: "travel_"+audits[i].id,
                    end: date_start.subtract(5, "minutes").format("YYYY-MM-DD HH:mm:ss"),
                    start: date_start_end.subtract(5, "minutes").subtract(Math.round(legs[i].duration.value), 'seconds').format("YYYY-MM-DD HH:mm:ss"),
                    resourceId: 'r2',
                    title: "Trajet de " + legs[i].distance.text+ " en " + Math.round(legs[i].duration.value / 60) + " minutes" ,
                    bgColor: '#f74e4b',
                });
            }

            // Vers l'arrivée
            var date_start2 = moment(audits[audits.length - 1].date).add(this.state.audit_duration, "hours");
            var date_start_end2 = moment(audits[audits.length - 1].date).add(this.state.audit_duration, "hours");
            data.push({
                id: "travel_end",
                end: date_start2.add(5, "minutes").add(Math.round(legs[legs.length - 1].duration.value), 'seconds').format("YYYY-MM-DD HH:mm:ss"),
                start: date_start_end2.add(5, "minutes").format("YYYY-MM-DD HH:mm:ss"),
                resourceId: 'r2',
                title: "Trajet de " + legs[legs.length - 1].distance.text+ " en " + Math.round(legs[legs.length - 1].duration.value / 60) + " minutes" ,
                bgColor: '#f74e4b',
            });

            // Pauses
            /*for (var k = 0; k < audits.length; k++){
                var date_end2 = moment(audits[k].date).add(this.state.audit_duration, 'hours');
                if(k < audits.length - 1 && date_end2.date() !== moment(audits[k+1].date).date()){
                    var date_start_next2 = moment(audits[k+1].date);
                    data.push({
                        id: "pause_"+audits[k].id,
                        start: date_end2.format("YYYY-MM-DD HH:mm:ss"),
                        end: date_start_next2.subtract(Math.round(legs[k].duration.value), 'seconds').format("YYYY-MM-DD HH:mm:ss"),
                        resourceId: 'r1',
                        title: "Pause" ,
                        bgColor: '#62f76e',
                    });
                }
            }*/
        }

        return data;
    }

    prevClick = (schedulerData)=> {
        schedulerData.prev();
        schedulerData.setEvents(this.formatAudits(this.props.audits, this.props.directions));
        schedulerData.setResources(resources);
        this.setState({
            viewModel: schedulerData
        })
    }

    nextClick = (schedulerData)=> {
        schedulerData.next();
        schedulerData.setEvents(this.formatAudits(this.props.audits, this.props.directions));
        schedulerData.setResources(resources);
        this.setState({
            viewModel: schedulerData
        })
    }

    onViewChange = (schedulerData, view) => {
        schedulerData.setViewType(view.viewType, view.showAgenda, view.isEventPerspective);
        schedulerData.setEvents(this.formatAudits(this.props.audits, this.props.directions));
        schedulerData.setResources(resources);
        this.setState({
            viewModel: schedulerData
        })
    }

    onSelectDate = (schedulerData, date) => {
        schedulerData.setDate(date);
        schedulerData.setEvents(this.formatAudits(this.props.audits, this.props.directions));
        schedulerData.setResources(resources);
        this.setState({
            viewModel: schedulerData
        })
    }

    eventClicked = (schedulerData, event) => {
        if(event.id.startsWith("audit_")){
            var id = event.id.replace('audit_', '');
            var audit = this.props.audits.find(audit => parseInt(audit.id, 10) === parseInt(id, 10));
            if(audit)
                this.props.handleMarkerClick(audit, true)
        }
    };
}

export default withDragDropContext(Readonly)


// WEBPACK FOOTER //
// ./src/component/utils/Scheduler.js